import { render, staticRenderFns } from "./SettingEdit.vue?vue&type=template&id=b5336c5c&scoped=true"
import script from "./SettingEdit.vue?vue&type=script&lang=js"
export * from "./SettingEdit.vue?vue&type=script&lang=js"
import style0 from "./SettingEdit.vue?vue&type=style&index=0&id=b5336c5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5336c5c",
  null
  
)

export default component.exports